import styled from "styled-components";
export const WrongLogin = styled.p`
  font-size: 15px;
  color: red;
  font-family: "Inter";
  position: fixed;
  margin-top: 185px;
  font-weight: 700;
`;
